import { render, staticRenderFns } from "./m-document-share-pro.vue?vue&type=template&id=70e1e573&scoped=true&lang=pug"
import script from "./m-document-share-pro.vue?vue&type=script&lang=js"
export * from "./m-document-share-pro.vue?vue&type=script&lang=js"
import style0 from "./m-document-share-pro.vue?vue&type=style&index=0&id=70e1e573&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e1e573",
  null
  
)

export default component.exports